import { Grid, Typography, withStyles } from '@material-ui/core';
import { Layers } from '@material-ui/icons';
import React from 'react';
import ItemsWithCheckMark from '../../../../Common/ItemsWithCheckMark';

const Includes = ({ classes, items }) => (
  <Grid container alignItems={"flex-start"}>
    <Grid item xs={1} className={classes.icon}>
      <Layers fontSize={'small'} color={'action'} />
    </Grid>
    <Grid item xs={10}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant={'h6'}>Includes</Typography>
        </Grid>
        <Grid item xs={12}>
          <ItemsWithCheckMark items={items} checkColor={'action'} />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

const styles = theme => ({
  icon: {
    paddingTop: theme.spacing(1),
  }
});
export default withStyles(styles)(Includes);
